<template>
    <div class="base-trumpet-explain" :class="{'trumpetexp-sp': $store.state.screen == 1}">
        <div class="content">
            <div class="title">小号说明</div>
            <div class="tips">
                1、在每个游戏里可创建最多10个小号；<br />
                2、每个小号相互独立，小号出售、回收不影响其他小号；<br />
                3、换区时，建议创建新的小号进入
            </div>
            <div class="btn" @click="onOut">我知道了</div>
        </div>
    </div>
</template>

<script>
    export default {
        methods: {
            // 关闭弹窗
            onOut () {
                this.$emit('childExplain', false)
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import "../../../../static/tctransition";
    $color: #FF6C22; // 主体颜色
    // 横屏css
    .base-trumpet-explain {
        width: 100%;
        height: 100%;
        background: rgba(0, 0, 0, 0.8);
        transition: all 0.3s;
        position: fixed;
        top: 0;
        left: 0;
        z-index: 999;
        .content {
            width: 840px;
            overflow: hidden;
            border-radius: 18px;
            background: $color;
            overflow: hidden;
            padding: 0 60px 60px;
            position: relative;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            .title {
                height: 160px;
                font-size: 51px;
                display: flex;
                align-items: center;
                justify-content: center;
            }
            .tips {
                font-size: 42px;
                margin-bottom: 50px;
            }
            .btn {
                width: 345px;
                height: 120px;
                color: $color;
                font-size: 39px;
                border-radius: 18px;
                background: #fff;
                margin: 55px auto 0;
                display: flex;
                align-items: center;
                justify-content: center;
            }
        }
    }
    // 竖屏css
    .trumpetexp-sp {
        .content {
            width: 1527px;
            border-radius: 32px;
            padding: 0 90px 90px;
            .title {
                height: 290px;
                font-size: 92px;
            }
            .tips {
                font-size: 76px;
                margin-bottom: 90px;
            }
            .btn {
                width: 627px;
                height: 200px;
                font-size: 70px;
                border-radius: 32px;
                margin: 100px auto 0;
            }
        }
    }
</style>